/* eslint-disable consistent-return */
/* eslint-disable immutable/no-let */
/* eslint-disable immutable/no-mutation */
'use client';
import { useEffect, useRef } from 'react';
import './ParticlesAnimation.css';

const ParticlesAnimation = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }

    const count = 20;
    for (let i = 0; i < count; i++) {
      const size = Math.random() * 8 + 4;
      const bubble = document.createElement('span');
      bubble.className = 'particle bubble';
      bubble.style.width = `${size}px`;
      bubble.style.height = `${size}px`;
      bubble.style.top = `${Math.random() * 80}%`;
      bubble.style.left = `${Math.random() * 100}%`;
      bubble.style.animationDelay = `${Math.random() * 0.5}s`;
      container.appendChild(bubble);
      bubble.addEventListener('animationend', () => {
        bubble.remove();
      });
    }
  }, []);

  return <div ref={containerRef} className="particle-container bubbles" />;
};

export default ParticlesAnimation;
